import React, { useEffect } from 'react';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import rupee_icon from '../../../images/icons/rupee_icon.svg';

function InputPrefixDropdown({
  name,
  dropdownName,
  max,
  min,
  maxLength,
  options,
  id,
  type = 'text',
  legendName,
  value,
  dropdownValue,
  onChangeDropdown,
  onChange,
  onBlur,
  onKeyUp,
  onKeyDown,
  onKeyPress,
  disabled,
  error,
  errorMsg,
  touched,
  stylesContainer = {},
  dropdownStyle = {},
  styleDropdownlist = {},
  legendStyle = {},
  inputStyle = {},
  onBlurStyle = {}
}) {
  return (
    <div className="grid_input_container relative ">
      <div
        style={{ marginTop: '17px' }}
        className="absolute text-grey-50 z-10  pt-px text-md ml-4"
      >
        <CommonSelect sort={true}
          name={dropdownName}
          value={dropdownValue}
          onChange={onChangeDropdown}
          options={options}
          stylesContainer={{
            height: '48px',
            marginBottom: '40px',
            left: '-15px',
            top: '-15px',
            width: '50px',
            border: 'none',
            borderRight: '1px solid #CBCBCB',
            borderRadius: '4px 0 0 4px',
            outline: 'none'
          }}
          dropdownStyle={{
            top: '55px',
            fontSize: '16px',
            ...dropdownStyle
          }}
          styleDropdownlist={{
            padding: '0px 4px',
            fontSize: '14px',
            ...styleDropdownlist
          }}
          styleText={{
            fontSize: '14px',
            padding: '0 9px',
            border: 'none'
          }}
        />
      </div>
      <div>
        <CommonInput
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          id={id}
          stylesContainer={{
            maxWidth: '100%',
            ...stylesContainer
          }}
          inputStyle={{
            paddingLeft: '60px',
            letterSpacing: '1px',
            ...inputStyle
          }}
          onBlurStyle={{
            paddingLeft: '30px',
            ...onBlurStyle
          }}
          legendStyle={{
            paddingLeft: '30px',
            ...legendStyle
          }}
          legendName={legendName}
          errorMsg={errorMsg}
          error={error}
          touched={touched}
        />
      </div>
    </div>
  );
}
export default InputPrefixDropdown;
